import React from 'react';
import ModernNode from './ModernNode';
import { NODE_TYPES } from '../../config/nodeConfig';

const AINode = (props) => {
  return <ModernNode {...props} nodeType={NODE_TYPES.AI} />;
};

export default AINode;